import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import { useContext } from "react";
import type { Components } from "react-markdown";
import { MarkdownContext } from "./markdown-context";

export const markdownTableElements = {
  table: function MarkdownTable({ children }) {
    const { variant } = useContext(MarkdownContext);
    return (
      <div
        {...stylex.props(
          styles.tableScroll,
          variant === "message" && styles.messageBlock,
          variant === "article" && styles.articleTableScroll,
        )}
      >
        <table
          {...stylex.props(
            styles.table,
            variant === "article" && styles.articleTable,
          )}
        >
          {children}
        </table>
      </div>
    );
  },
  th: function MarkdownHeaderCell({ children, style }) {
    const article = useContext(MarkdownContext).variant === "article";
    return (
      <th
        {...stylex.props(
          styles.cell,
          styles.tableHeader,
          article && styles.articleCell,
          article && styles.articleHeaderCell,
          style?.textAlign === "center" && styles.alignCenter,
          style?.textAlign === "right" && styles.alignRight,
        )}
      >
        {children}
      </th>
    );
  },
  td: function MarkdownCell({ children, style }) {
    const article = useContext(MarkdownContext).variant === "article";
    return (
      <td
        {...stylex.props(
          styles.cell,
          article && styles.articleCell,
          style?.textAlign === "center" && styles.alignCenter,
          style?.textAlign === "right" && styles.alignRight,
        )}
      >
        {children}
      </td>
    );
  },
} satisfies Components;

const styles = stylex.create({
  tableScroll: { overflowX: "auto", marginBlock: spacing.space20 },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: fontSizes.label,
  },
  cell: {
    paddingBlock: spacing.space8,
    paddingInline: spacing.space12,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: colors.border,
    textAlign: "left",
    verticalAlign: "top",
  },
  tableHeader: { backgroundColor: colors.surfaceAlt, fontWeight: 600 },
  alignCenter: { textAlign: "center" },
  alignRight: { textAlign: "right" },
  // A message keeps its blocks close and flush with its card's edges.
  messageBlock: {
    marginBlock: 0,
    marginTop: { default: spacing.space8, ":first-child": 0 },
  },
  articleTableScroll: { marginBlock: 18 },
  articleTable: { fontSize: 15, lineHeight: 1.5 },
  articleCell: {
    borderBottomColor: "rgba(22, 22, 22, 0.08)",
    paddingBlock: 6,
    paddingInline: 10,
  },
  articleHeaderCell: {
    backgroundColor: "transparent",
    borderBottomColor: "rgba(22, 22, 22, 0.2)",
    color: colors.foreground,
  },
});
